import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { ErrorScreen } from '../../components/errors/ErrorScreen';
import { MDBIcon } from 'mdb-react-ui-kit';
import { OpGroupListItemDTO } from '@scm/common-legacy';

export const GroupsOperatorPage = ({
    groups,
}: {
    groups: OpGroupListItemDTO[];
}) => {
    const { t } = useTranslation();

    return (
        <div className="d-flex flex-column flex-fill align-items-center overflow-hidden">
            {groups.length > 0 && (
                <>
                    {t('select_group')}
                    <div
                        className="list-group list-group-light d-flex align-items-center my-3 overflow-auto"
                        style={{ width: '75%', maxWidth: 300 }}
                    >
                        {groups.map((g) => (
                            <NavLink
                                key={g.Name}
                                to={'group/' + g.id}
                                className="list-group-item list-group-item-action px-3"
                            >
                                <div
                                    className={
                                        'text-dark' +
                                        (g.defaultGroup
                                            ? ' fst-italic warning-row'
                                            : '')
                                    }
                                >
                                    <MDBIcon
                                        icon="layer-group"
                                        color="primary"
                                        className="me-1"
                                    />
                                    <span
                                        style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {g.defaultGroup && (
                                            <span>
                                                <MDBIcon
                                                    icon="bookmark"
                                                    color="warning"
                                                    className="me-1"
                                                />
                                            </span>
                                        )}
                                        {g.Name}
                                    </span>
                                </div>
                            </NavLink>
                        ))}
                    </div>
                </>
            )}
            {groups.length == 0 && (
                <div className="flex-fill my-5">
                    <ErrorScreen title={t('no_groups')} />
                </div>
            )}
        </div>
    );
};
